import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { candidateService } from '../services/candidate.service';
import type { CreateCandidateRequest, Candidate } from '../types/candidate.types';

export function useCreateCandidate(): {
  createCandidate: UseMutateFunction<Candidate, Error, CreateCandidateRequest>;
  createCandidateAsync: (data: CreateCandidateRequest) => Promise<unknown>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
  reset: () => void;
} {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data: CreateCandidateRequest) => candidateService.createCandidate(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['candidates'] });
    },
  });

  return {
    createCandidate: mutation.mutate,
    createCandidateAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    reset: mutation.reset,
  };
}
